import React from 'react';
import {memo} from 'react'
import style from './contentArena.module.scss'
import {ReactComponent as ArenaIcon} from "./images/arena-small-logo.svg";
import {ReactComponent as PointsIcon} from "./images/points.svg";
import {ReactComponent as RatingsIcon} from "./images/ratings.svg";
import classNames from "classnames";

const ContentArena = memo(({ranking, points, pointsDifference}) => {

  const pointsDifferenceClass = classNames('difference-points', {
    [style.positiveDifference]: pointsDifference > 0,
    [style.negativeDifference]: pointsDifference < 0,
    [style.noneDifference]: pointsDifference === 0
  });

  return (
    <div className={style.arena}>
      <div className={style.logo}>
        <ArenaIcon/>
      </div>

      <div className={style.results}>
        <div className={style.ranking}>
          <div className={style.resultsWrapper}>
            <div className={style.resultsIcon}>
              <RatingsIcon/>
            </div>
            <div className={style.value}> {ranking ? ranking : "-"} </div>
          </div>
          <div className={style.text}>Your Ranking</div>
        </div>

        <div className={style.points}>
          <div className={style.resultsWrapper}>
            <div className={style.resultsIcon}>
              <PointsIcon/>
            </div>
            <div className={style.value}> {points ? points : "-"} </div>
            <div className={pointsDifferenceClass}>
              {pointsDifference > 0 ? '+' : ''}
              {pointsDifference}
            </div>
          </div>

          <div className={style.text}>Your Points</div>
        </div>
      </div>
    </div>
  );
})

export default ContentArena;
